import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/SEO/JsonLd';
import HeroSection from './components/HeroSection';
import DailyUpdateSection from './components/DailyUpdateSection';
import CategorySection from './components/CategorySection';
import AboutSection from './components/AboutSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';

export default function Home() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩漫大全',
    url: 'http://knn08.com/',
    logo: 'http://knn08.com/logo.png',
    description: '韩漫大全免费平台是韩国漫画在线阅读网标杆，每日更新最新章节，提供海量韩漫资源，支持评论与收藏功能。',
    sameAs: ['http://knn08.com/'],
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩漫大全 - 韩国漫画在线阅读网',
    url: 'http://knn08.com/',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'http://knn08.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '韩漫大全 - 韩国漫画在线阅读网',
    description: '每日更新最新章节，提供海量韩漫资源，支持评论与收藏功能，让您随时随地畅享韩漫阅读乐趣。',
    url: 'http://knn08.com/',
    isPartOf: { '@type': 'WebSite', name: '韩漫大全', url: 'http://knn08.com/' },
    about: { '@type': 'Thing', name: '韩国漫画' },
    primaryImageOfPage: {
      '@type': 'ImageObject',
      url: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20collage%20featuring%20multiple%20beautiful%20illustrated%20characters%20in%20dynamic%20poses%2C%20vibrant%20color%20palette%20with%20warm%20olive%20green%20and%20soft%20cream%20tones%2C%20artistic%20composition%20with%20floating%20manga%20panels%2C%20decorative%20Korean%20pattern%20elements%2C%20dreamy%20atmospheric%20lighting%2C%20clean%20aesthetic%2C%20modern%20editorial%20design%20with%20soft%20gradients&width=1800&height=1200&seq=hero-bg-main&orientation=landscape',
    },
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'http://knn08.com/' },
    ],
  };

  return (
    <>
      <JsonLd data={[orgSchema, websiteSchema, webPageSchema, breadcrumbSchema]} />
      <Navbar />
      <main>
        <HeroSection />
        <DailyUpdateSection />
        <CategorySection />
        <AboutSection />
        <TestimonialSection />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}